module.exports = __webpack_public_path__ + "static/watch.619dc360.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/watch.png
// module id = 611
// module chunks = 54681204059826